import { Button, Modal } from "antd";
import {
  CheckOutlined,
  ClearOutlined,
  FilterOutlined,
} from "@ant-design/icons";
import { useMediaQuery } from "../../hooks";
import ModalTitle from "../ModalTitle";
import styles from "./styles.module.css";

const FilterDialog = ({
  open,
  onClose,
  title = "فیلترها",
  subtitle,
  icon = <FilterOutlined />,
  onClear,
  onApply,
  loading,
  clearText = "پاک کردن",
  applyText = "اعمال",
  width = 520,
  children,
}) => {
  const isMobile = useMediaQuery("(max-width: 575px)");

  return (
    <Modal
      open={open}
      onCancel={onClose}
      className="ds-modal"
      width={isMobile ? "95vw" : width}
      centered
      destroyOnClose={false}
      title={<ModalTitle icon={icon} title={title} subtitle={subtitle} />}
      footer={
        <div className={styles.footer}>
          {onClear ? (
            <Button icon={<ClearOutlined />} onClick={onClear}>
              {clearText}
            </Button>
          ) : (
            <span />
          )}
          <Button
            type="primary"
            icon={<CheckOutlined />}
            loading={loading}
            onClick={onApply}
          >
            {applyText}
          </Button>
        </div>
      }
    >
      <FilterFields>{children}</FilterFields>
    </Modal>
  );
};

export const FilterFields = ({ children }) => (
  <div className={styles.fields}>{children}</div>
);

export const FilterField = ({ label, span = 12, children }) => (
  <div className={styles.field} style={{ "--field-span": span }}>
    {label && <span className={styles.label}>{label}</span>}
    {children}
  </div>
);

export default FilterDialog;
